import { Button } from '@chakra-ui/button'
import { PDFDownloadLink } from '@react-pdf/renderer'
import { ConsolidatedReport, Report } from 'layouts/dash/types'
import React, { useEffect, useState } from 'react'
import { FaPrint } from 'react-icons/fa'
import { generateImgLink } from 'utils/generateImgLink'

interface IProps {
  Report: React.FC<Report> | React.FC<ConsolidatedReport>
  chartRefs: any[]
  title: string
  selectedUserName: string
  selectedCompany: string
  responses: React.MutableRefObject<any>
  responsesRefs: React.MutableRefObject<any>[]
}

function sleep(s: number) {
  return new Promise((resolve) => setTimeout(resolve, s * 1000))
}

function ReportLink(props: IProps): JSX.Element {
  const { Report, title, chartRefs, selectedUserName, selectedCompany, responses, responsesRefs } = props

  const [links, setLinks] = useState<string[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const elements: any[] = []
    chartRefs.forEach((ref, index) => {
      if (index < 5) {
        elements.push(ref.current)
      } else {
        ref.current.childNodes.forEach((child: any) => {
          elements.push(child)
        })
      }
    })
    async function getLinks() {
      await sleep(3)
      const chartPromises = elements.map(async (el, index) => {
        const imgLink = await generateImgLink(el)
        const href = imgLink.href
        return href
      })
      const chartResponses = await Promise.all(chartPromises)

      let proceed = true
      chartResponses.forEach((a) => {
        if (a.length < 6000 && a.length > 0) {
          return (proceed = false)
        }
      })
      if (proceed) {
        setLinks(chartResponses)
        setLoading(false)
      } else {
        getLinks()
      }
    }
    getLinks()
  }, [chartRefs])

  return (
    <>
      {links.length > 0 && !loading ? (
        <PDFDownloadLink
          document={
            <Report
              title={title}
              chartRefs={chartRefs}
              reportTarget={{
                name: selectedUserName ?? '',
                company: selectedCompany ?? '',
              }}
              links={links}
              responses={responses}
              responsesRefs={responsesRefs}
            />
          }
          fileName={`${title.replaceAll(' ', '_').toLowerCase()}-${selectedCompany
            .replaceAll(' ', '_')
            .toLowerCase()}-${selectedUserName.replaceAll(' ', '_').toLowerCase()}.pdf`}
        >
          {({ url, loading }) => {
            return (
              <Button
                variant="outline"
                w="9.8125rem"
                h="8"
                fontSize="0.75rem"
                leftIcon={<FaPrint size={18} />}
                isLoading={loading || !url}
              >
                Imprimir Relatório
              </Button>
            )
          }}
        </PDFDownloadLink>
      ) : (
        <Button
          variant="outline"
          w="9.8125rem"
          h="8"
          fontSize="0.75rem"
          leftIcon={<FaPrint size={18} />}
          isLoading={true}
          disabled={true}
        >
          Imprimir Relatório
        </Button>
      )}
    </>
  )
}

export default ReportLink
